import type {ComponentPropsWithoutRef} from 'react';
import {forwardRef} from 'react';
import {cva, type VariantProps} from 'class-variance-authority';

import {cn} from '@/utils/tailwind';

const badgeStyles = cva(
	cn(
		'inline-flex',
		'items-center',
		'justify-center',
		'shrink-0',
		'rounded-lg',
		'px-[15px]',
		'pt-[6px]',
		'pb-[5px]',
		'border',
	),
	{
		variants: {
			variant: {
				primary: [
					'border-primary-border-strong',
					'text-primary-text-default',
				],
				secondary: [
					'text-secondary-text-subtle!',
					'border-secondary-border-strong',
				],
			},
			size: {
				medium: ['text-body-short-md'],
				small: ['text-body-short-xs'],
				large: ['text-body-short-lg'],
			},
		},
		defaultVariants: {
			variant: 'primary',
			size: 'medium',
		},
	},
);

export type BadgeProps = VariantProps<typeof badgeStyles> &
	ComponentPropsWithoutRef<'div'>;

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
	({children, variant = 'primary', className, size, ...rest}, ref) => {
		return (
			<span
				ref={ref}
				className={cn(badgeStyles({variant, size}), className)}
				{...rest}
			>
				{children}
			</span>
		);
	},
);

Badge.displayName = 'Badge';
